import { useMemo } from 'react';
import { useHistory, useIntl } from 'umi';
import QOQValue from '../columns/components/QOQValue';
import React from 'react';
import { tableColumnsList } from '@op/pages/Compare/ChannelShareRanking/constants';
import useGameCountryPublisher from '@op/pages/competitor/hooks/useGameCountryPublisher';
import GameItem from '@op/components/GameItem';
import RegionCountryItem from '@op/components/Snippets/RegionCountryItem';
import BubbleCommon, {
  compareChannelShareRankingsGameTips,
} from '@op/components/BubbleCommon';
import HoverSortCommon from '@op/components/HoverSortCommon';
import { goStatsDetailAction } from '@op/pages/stats/Detail';
import { buriedBtnPoint } from '@op/operationLog/buriedPoint';
import SvgIcon from '@home/components/SvgIcon';

export default function useChannelShareRankings({
  selectGameList,
  toggleExpand,
  sort,
  setSort,
  filter = {},
}: {
  selectGameList: Array<any>;
  toggleExpand: (visible: boolean) => void;
  sort: any;
  setSort: any;
  filter: any;
}) {
  const { formatMessage } = useIntl();

  const history = useHistory();
  function gotoFeeds(id: any) {
    toggleExpand(true);

    goStatsDetailAction({
      path: `/opinion/Feeds/Feeds?gameid=${id}`,
      params: filter,
      history,
    });
  }

  const { gameCountryMap } = useGameCountryPublisher({
    selected: selectGameList,
  });

  const columns = useMemo(() => {
    const list = tableColumnsList.map(
      ({ text, value, isPercentage = false, tips, ...otherInfo }) => {
        return {
          key: value,
          header: (
            <HoverSortCommon
              sort={sort}
              sortOptions={[
                {
                  text: formatMessage(
                    { id: 'Sort by {name}' },
                    { name: formatMessage({ id: text }) },
                  ),
                  value: value,
                },
                {
                  text: formatMessage(
                    { id: 'Sort by {name} Change%' },
                    { name: formatMessage({ id: text }) },
                  ),
                  value: value + '_qoq',
                },
              ]}
              sortChange={(sort: { by: string; order: 'asc' | 'desc' }) => {
                setSort(sort);
              }}
            >
              <BubbleCommon showIcon={false} placement="top" tipsMap={tips}>
                {formatMessage({ id: text })}
              </BubbleCommon>
            </HoverSortCommon>
          ),
          ...otherInfo,
          render: (data: any) => {
            return (
              <QOQValue
                item={data}
                valueKey={value}
                title={text}
                linkTime={data.times}
                progressVisible={false}
                isPercentage={isPercentage}
              ></QOQValue>
            );
          },
        };
      },
    );

    const columns: Array<any> = [
      {
        key: 'game_id',
        header: 'Game',
        width: 260,
        fixed: 'left',
        render: (data: any) => {
          const {
            edition_unified_id: key,
            country: dataCountry,
            publisher: dataPublisher,
            entity_type,
          } = data || {};
          const item = gameCountryMap[key];
          const country = item?.country || dataCountry;
          const publisher = item?.publisher || dataPublisher;

          return (
            <GameItem
              tipsMap={compareChannelShareRankingsGameTips(data.entity_name)}
              gameInfo={{ ...data, country, publisher }}
              handleGameClick={(e: any) => {
                e.stopPropagation();
                gotoFeeds(key);
                buriedBtnPoint('GotoGamePage', data);
              }}
            >
              <div className="dbo-gameitem-content">
                <SvgIcon
                  className='dbo-gameitem-entity-icon'
                  type={
                    entity_type == 'mobile'
                      ? 'other-icon'
                      : entity_type == 'pc'
                      ? 'monitor'
                      : 'merit'
                  }
                />
                <RegionCountryItem
                  showText={false}
                  iconClassName="dbo-gameitem-content"
                  market={country}
                ></RegionCountryItem>
                <div className="dbo-gameitem-text">{publisher}</div>
              </div>
            </GameItem>
          );
        },
      },
      ...list,
    ];

    return columns;
  }, [formatMessage, gameCountryMap, sort]);

  return columns;
}
